import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HPlusMobiledataIcon(props: IconProps) {
    return <Icon {...props} iconKey={"h_plus_mobiledata"}/>
}
